const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1"]);

export function getApiBaseUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace(/\/+$/, "");
  }

  if (typeof window === "undefined") {
    return "/api";
  }

  const { origin, hostname } = window.location;
  if (LOCAL_HOSTS.has(hostname)) {
    return "http://localhost:5000/api";
  }

  return `${origin}/api`;
}

export const API = getApiBaseUrl();
